import axiosInstance from './axiosInstance';
import authService from './authService';

const postService = {
  getPosts: async () => {
    try {
      if (!authService.isTokenValid()) {
        throw new Error('No valid authentication token found');
      }
      const response = await axiosInstance.get('/api/posts');
      return response.data;
    } catch (error) {
      console.error('Get posts error:', error);
      throw error;
    }
  },

  getPost: async (id) => {
    try {
      const response = await axiosInstance.get(`/api/posts/${id}`);
      return response.data;
    } catch (error) {
      console.error('Get post error:', error);
      throw error;
    }
  },

  createPost: async (postData) => {
    try {
      const response = await axiosInstance.post('/api/posts', postData);
      return response.data;
    } catch (error) {
      console.error('Create post error:', error);
      throw error;
    }
  },

  updatePost: async (id, postData) => {
    try {
      const response = await axiosInstance.put(`/api/posts/${id}`, postData, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Update post error:', error);
      throw error;
    }
  },

  deletePost: async (id) => {
    try {
      await axiosInstance.delete(`/api/posts/${id}`);
    } catch (error) {
      console.error('Delete post error:', error);
      throw error;
    }
  },

  schedulePost: async (postId, scheduledDate, postToLinkedIn = false) => {
    try {
      const response = await axiosInstance.post(
        `/api/posts/${postId}/schedule`,
        { 
          scheduled_date: scheduledDate,
          post_to_linkedin: postToLinkedIn 
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error scheduling post:', error);
      throw error;
    }
  },

  savePost: async (postData) => {
    try {
      const response = await axiosInstance.post('/api/posts', postData);
      return response.data;
    } catch (error) {
      console.error('Save post error:', error);
      throw error;
    }
  },

  hasAvailableCredits: async (type) => {
    try {
      const response = await axiosInstance.get(
        '/api/payments/subscription',
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );

      // Get credits from user_credits table
      const creditsResponse = await axiosInstance.get(
        '/api/credits',
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );

      const credits = creditsResponse.data;
      const subscription = response.data.subscription;

      // If user has an active subscription, they have unlimited credits
      if (subscription && subscription.status === 'active') {
        return true;
      }

      // Check credits based on type
      if (type === 'post') {
        // -1 means unlimited credits
        return credits.post_credits === -1 || credits.post_credits > 0;
      } else if (type === 'image') {
        // -1 means unlimited credits
        return credits.image_credits === -1 || credits.image_credits > 0;
      }

      return false;
    } catch (error) {
      console.error('Error checking credits:', error);
      return false;
    }
  }
};

export default postService; 